/**
 * Icon Graphic
 * @figma https://www.figma.com/design/9RrH1KYIUOZk6rvgzlBBKX/WEB-BAU-2026?node-id=20683-81940&m=dev
 */
const IconGraphic = (): React.ReactElement => {
  return (
    <g data-testid="icon-graphic">
      <path
        d="M27.6715 8.24233L37.3332 9.91796L35.2638 3.50232L2.6665 14.0134L17.3416 59.5023L28.9851 55.7481L19.7191 54.1413L27.6714 8.24464L27.6715 8.24233ZM26.4532 55.9258L17.7302 58.739L3.43012 14.4048L34.8702 4.26559L36.4466 9.15031L27.1787 7.54343L25.0549 19.8013L21.9521 17.5142C21.7861 17.391 21.5704 17.3626 21.3761 17.436C21.1841 17.5095 21.0395 17.6778 20.9992 17.8792C20.2833 21.3206 19.1266 26.7315 18.7568 28.1774C18.0765 27.9143 16.6212 27.1227 15.417 26.3927C15.27 26.3027 15.0899 26.279 14.924 26.3311C14.758 26.3832 14.6229 26.5017 14.5495 26.6605L11.302 33.8182C11.1646 34.124 11.2997 34.4842 11.6031 34.6217C11.6837 34.6596 11.769 34.6762 11.852 34.6762C12.0843 34.6762 12.3023 34.5434 12.4043 34.3207L15.3696 27.7843C18.5032 29.6424 19.0436 29.5121 19.2569 29.4599C19.4442 29.4125 19.6006 29.2987 19.6978 29.14C19.9325 28.7489 21.0347 23.6414 21.9923 19.0578L24.3958 20.8283C24.5333 20.9302 24.7016 20.9634 24.8604 20.9349L19.0696 54.3431L19.0174 54.6417L26.4582 55.931L26.4532 55.9258Z"
        fill="currentColor"
      />

      <path
        d="M30.1964 7.50232L22.7171 53.4489L22.6665 53.7574L53.8032 59.5023L61.2826 13.5557L61.3332 13.2472L30.1964 7.50232ZM53.3222 58.78L23.3471 53.2482L30.6745 8.2275L60.6496 13.7593L53.3222 58.78Z"
        fill="currentColor"
      />

      <path
        d="M30.6665 33.6379L32.8525 20.8356L35.9998 21.3666L33.8139 34.1689L30.6665 33.6379Z"
        fill="currentColor"
      />

      <path
        d="M34.6665 34.9385L36.6327 23.5023L39.9998 24.0661L38.0337 35.5023L34.6665 34.9385Z"
        fill="currentColor"
      />

      <path
        d="M40 34.9033L42.9722 18.1689L46.6667 18.7679L43.6945 35.5023L40 34.9033Z"
        fill="currentColor"
      />

      <path
        d="M45.3335 36.2563L47.5605 26.1689L52.0002 26.7482L49.7732 36.8356L45.3335 36.2563Z"
        fill="currentColor"
      />

      <path
        d="M32.5323 44.1429C32.5962 44.3233 32.7311 44.4625 32.8991 44.5244C33.0672 44.5862 33.2518 44.5682 33.4057 44.4677L36.5608 42.4366L37.1597 43.4418C37.2543 43.6016 37.4082 43.7099 37.5833 43.7356C37.7561 43.764 37.9313 43.7073 38.0662 43.5836L40.0687 41.7045L48.3149 49.9937C48.4309 50.1097 48.58 50.1689 48.7268 50.1689C48.8901 50.1689 49.0534 50.0968 49.1718 49.9576C49.399 49.6895 49.3848 49.2719 49.1386 49.0245L40.4943 40.3354C40.267 40.1086 39.9215 40.1008 39.6872 40.3199L37.803 42.0882L37.2657 41.186C37.0882 40.8896 36.7284 40.7968 36.4491 40.9772L33.4052 42.9362L31.8359 38.5878C31.7152 38.2476 31.3602 38.0826 31.0501 38.2141C30.7377 38.3481 30.5862 38.7296 30.7093 39.0699L32.5389 44.14L32.5323 44.1429Z"
        fill="currentColor"
      />
    </g>
  );
};

export default IconGraphic;
